export default __webpack_public_path__ + "assets/fonts/UBUNTU-B.TTF";